var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Common',{attrs:{"text":"404，未找到该页面。"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }